<template>
<!-- heyan -->
  <el-container class="content-index-container left-container" :noRoute="true">
    <el-main>
      <el-tabs v-model="currentTab" @tab-click="changeTab">
        <template v-for="(tab, index) in tabs">
          <el-tab-pane :name="tab.name" :key="index">
            <label slot="label" style="cursor: pointer;">{{tab.label}}
              <!-- <jee-icon iconClass="caozuoshuoming1" @click="tab.showAlert = !tab.showAlert" :style="{fontSize: '16px'}"/> -->
            </label>
            <el-collapse-transition>
              <div v-show="tab.showAlert" style="margin-bottom:20px">
                <el-alert
                  :title="$t(tab.content)"
                  type="warning"
                  show-icon
                  @close="tab.showAlert = false"
                ></el-alert>
              </div>
            </el-collapse-transition>
            <component
              :is="tab.component" :name="currentTab" :isChild="isChild" :id="channelId" :key="index"/>
          </el-tab-pane>
        </template>
      </el-tabs>
    </el-main>
  </el-container>
</template>

<script>
import todoList from './components/TodoList'
import replyList from './components/ReplyList'
import digestList from './components/DigestList'
export default {
  name: 'contentIndex',
  components: {
    todoList,
    replyList,
    digestList
  },
  provide () {
    return {
      changeCurrentTab: this.changeCurrentTab
    }
  },
  data () {
    return {
      isChild: false, // 是否最底层
      currentTab: 'todo',
      channelId: '',
      tabs: [
        {
          label: '待办理',
          name: 'todo',
          showAlert: false,
          component: 'todoList'
        },
        {
          label: '已回复',
          name: 'reply',
          showAlert: false,
          component: 'replyList'
        },
        {
          label: '已选登',
          name: 'digest',
          showAlert: false,
          component: 'digestList'
        },
      ],
    }
  },
  methods: {
    changeTab (tab, e) {
      this.channelId = this.channelId
    },
    changeCurrentTab () {
      this.currentTab = 'audit'
    }
  },
  activated () {
    
  },
  mounted () {
    
  }

}
</script>

<style lang="scss">
  .content-index-container{
    .left-head{
      padding:10px 10px 0;
      height: 46px;
      border: none;
    }
    .el-tabs__content{
      padding-bottom: 30px !important;
    }
  }
</style>
